import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PccPatientGuard implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._authService.currentUser?.has_pcc_account) {
      return true;
    }
    else {
      this._router.navigate(['patients/matrix-list']);
      return false;
    }
  }

}
